@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../constants/spacing.module.less';

.description {
  margin: @space-0;
  padding: @space-0;
  font-size: 12px;
  font-weight: @normal;
  line-height: 12px;
  color: var(--default--disabled--text-color--4);
}

.require {
  margin-top: @space-16;
  margin-bottom: @space-16;
  cursor: pointer;
}

.no-carriers {
  margin-top: 40px;
  margin-bottom: 40px;
}

.checkbox-slider {
  margin-top: 2px;
}
